<template>
  <div class="p-media-list">
    <div v-for="(category, index) in posts" :key="index">
      <template v-if="category.items.length > 0">
      <h3 @click="open(category.slug)" :class="{ opened : isOpened === category.slug }">{{category.label}}</h3>
      <transition
          name="slide"
          @before-enter="(el) => (el.style.height = '0')"
          @enter="(el) => (el.style.height = el.scrollHeight + 'px')"
          @before-leave="(el) => (el.style.height = el.scrollHeight + 'px')"
          @leave="(el) => (el.style.height = '0')"
      >
        <div v-show="isOpened === category.slug" class="list-body">
          <template v-for="item in category.items">
            <h4>{{item.year}}</h4>
            <div v-html="item.content"></div>
          </template>
        </div>
      </transition>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "Accordion",
  data(){
    return {
      isOpened: '',
      posts: [
        {
          slug: 'media',
          label: 'メディア',
          items: [],
        },
        {
          slug: 'lecture',
          label: '講演',
          items: [],
        },
        {
          slug: 'presentation',
          label: '学会・イベントでの発表',
          items: [],
        },
        {
          slug: 'grant',
          label: '助成・補助',
          items: [],
        }
      ],
    }
  },
  created() {
    this.getAchievements();
  },
  methods: {
    open(target){
      if(this.isOpened !== target) {
        this.isOpened = target
      } else {
        this.isOpened = ''
      }
    },
    getAchievements() {
      const sendData = {
        action: "get_about_achievements",
        _security: AJAX_TARGET.nonce,
      };
      const params = new URLSearchParams(sendData);
      axios
          .post(AJAX_TARGET.api, params)
          .then(( { data }) => {
            this.posts[0].items = data.media.items
            this.posts[1].items = data.lecture.items
            this.posts[2].items = data.presentation.items
            this.posts[3].items = data.grant.items
          })
          .catch((error) => {
            console.log(error);
          });
    }
  }
}
</script>

<style lang="scss">

.p-media-list {
  @apply mx-auto mt-8 bg-white mb-[66px] md:mb-[116px];

  h3 {
    background: #333333;
    @apply text-24 text-white tracking-widest py-2 px-6 cursor-pointer relative font-light;
    margin-top: 1px;

    &:before, &:after {
      content: '';
      display: block;
      width: 12px;
      height: 1px;
      background: #fff;
      @apply right-4 top-0 bottom-0 absolute m-auto;
    }

    &:before {
      transform: rotate(270deg);
      transition: transform 0.2s;
    }

    &.opened {
      &:before {
        transform: rotate(0deg);
      }
    }
  }

  h4 {
    @apply text-base font-bold tracking-wider relative inline-block leading-none px-2;

    &:first-child {
      @apply mt-8;
    }

    &:before {
      position: absolute;
      bottom: 0;
      left: 0;
      content: '';
      width: 100%;
      height: 0.4em;
      background: #dbdbdb;
      mix-blend-mode: multiply;
    }
  }
  .list-body {
    padding: 0 2rem 0;
    overflow: hidden;
    transition: 500ms ease-out;

    ul {
      @apply text-13 mb-12;
    }

    li {
      @apply border-b py-5 pl-2 tracking-wider;
      text-indent: -1em;
      border-color: #d5d5d5;
      color: #666666;
      &:before {
        content: '・';
      }

      a {
        @apply underline hover:no-underline;
      }
    }
  }
}
</style>